import { createFileRoute } from "@tanstack/react-router";
import {
  IntersectionPage,
  buildIntersectionHead,
} from "@/components/IntersectionPage";
import { INTERSECTION_CONFIGS } from "@/lib/intersectionData";

const CONFIG = INTERSECTION_CONFIGS.find((c) => c.slug === "dental-web-design-denver")!;

export const Route = createFileRoute("/dental-web-design-denver")({
  head: () => buildIntersectionHead(CONFIG),
  component: () => <IntersectionPage config={CONFIG} />,
});
